import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';

export const LAWN_CARE = "lawn-care";
export const TREE_TRIMMING = "tree-trimming";
export const PREVIOUS_OWNER = "previous-owner";
export const HANDYMAN = "handyman";
export const PLUMBING = "plumbing";
export const PAINTER = "painter";
export const HVAC_CONTRACTOR = "hvac-contractor";
export const HOME_INSPECTOR = "home-inspector";
export const HOME_STAGER = "home-stager";
export const HOME_WARANTY = "home-waranty";
export const HOMEOWNERS_INSURANCE_AGENT = "homeowners-insurance-agent";
export const ATTORNEY = "attorney";
export const LOAN_OFFICER = "loan-officer";
export const MOVER = "mover";
export const PHOTOGRAPHER = "photographer";
export const REAL_ESTATE_AGENT = "real-estate-agent";
export const TITLE_ESCROW_AGENT = "title-escrow-agent";

export const TYPES = {
    LAWN_CARE,
    TREE_TRIMMING,
    PREVIOUS_OWNER,
    HANDYMAN,
    PLUMBING,
    PAINTER,
    HVAC_CONTRACTOR,
    HOME_INSPECTOR,
    HOME_STAGER,
    HOME_WARANTY,
    HOMEOWNERS_INSURANCE_AGENT,
    ATTORNEY,
    LOAN_OFFICER,
    MOVER,
    PHOTOGRAPHER,
    REAL_ESTATE_AGENT,
    TITLE_ESCROW_AGENT,
};

class LuPropertyContactTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'lu-property-contact-type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/properties/contacts/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'created_at',
            'updated_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'title',
            'professionalTitle',
            'slug',
            'description',
            'isSystem',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {};
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            title: {
                type: 'string',
                presence: true,
            },
            professionalTitle: {
                type: 'string',
            },
            slug: {
                type: 'string',
            },
            isSystem: {
                type: 'boolean',
            },
            description: {
                type: 'string',
            },
        };
    }

}

export default LuPropertyContactTypeAppResource;
